import { render, staticRenderFns } from "./UserCategories.vue?vue&type=template&id=d48c7d54"
import script from "./UserCategories.vue?vue&type=script&lang=ts"
export * from "./UserCategories.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports